<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 顶部栏 -->
      <div class="topbar">
        <div>
          <el-input v-model="searchValue" size="small" placeholder="视频标题/视频描述" prefix-icon="el-icon-search"
                    class="search-input" clearable @keyup.enter.native="search()"/>
          <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                     @click.stop="search()">
            搜索
          </el-button>

          <el-row style="padding-top: 20px;display: flex;">

            <el-col>
              <el-select v-model="curCategoryOption" clearable
                         @change="curCategoryChange">
                <el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
                           :value="item.forumCategoryId" :label="item.categoryName"></el-option>
              </el-select>
            </el-col>
            <el-col>
              <el-select v-model="curSortOption" clearable style="padding-left: 20px;"
                         @change="curSortOptionChange">
                <el-option v-for="item in sortOptions" :key="item.value" :value="item.value"
                           :label="item.name">
                </el-option>
              </el-select>
            </el-col>
            <el-col style="padding-left: 20px;">
              <el-select clearable v-model="curTabOption" @change="curTabOptionChange">
                <el-option v-for="item in tabOptions" :value="item.liveVideoTabId"
                           :label="item.liveVideoTabTitle" :key="item.liveVideoTabId"/>
              </el-select>
            </el-col>

          </el-row>
          <el-row>
            <el-col>
              <el-select v-if="userOptions.length > 0" v-model="curUserOption" clearable style="padding-top: 20px;"
                         @change="curUserOptionChange">
                <el-option v-for="item in userOptions" :key="item.value" :value="item.value"
                           :label="item.name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>


          <!-- <el-row style="display: flex;padding-top: 20px;">

            <el-col v-for="(type,index) in filterOptions" :key="type.maiColumnConditionID"
              style="padding-right: 20px;">
              <el-select v-model="curFilterOptions[index]" clearable @change="curFilterOptionChange">
                <el-option v-for="condiction in type.childConditionList"
                  :key="condiction.maiColumnConditionID" :value="condiction"
                  :label="condiction.showName"></el-option>
              </el-select>
            </el-col>
          </el-row> -->

        </div>

        <div>
          <!-- TODO 新增新视频 -->
          <el-row>
            <el-button type="primary" size="small" icon="el-icon-plus" @click.stop="addReview()">
              新增视频
            </el-button>
            <el-button type="primary" size="small" @click="go2uploadmanager">上传任务</el-button>
          </el-row>
          <el-row  style="padding-top: 20px">
            <el-button :disabled="!isVaild(curTabOption)" type="primary" @click="exportVideoTabAllWatchData()" size="small">导出该系列视频观看信息
            </el-button>
          </el-row>

        </div>

      </div>
      <!-- 内容 -->
      <el-table v-loading="loading" :data="tableData" :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px" border>
        <el-table-column prop="liveId" label="ID" align="center" width="50"/>
        <el-table-column prop="uploaderInfo" label="上传者" align="center" width="100">
          <template #default="props">
            <user-info :user="props.row"></user-info>
          </template>
        </el-table-column>
        <el-table-column prop="liveTitle" label="视频标题" align="center"/>
        <el-table-column prop="liveCover" label="视频" align="center" width="120">
          <template #default="props">
            <div style="width: 100px; height: 100px;position: relative; display: flex;justify-content: center;">
              <el-image fit="scale-down" :key="props.row.LiveCover"
                        :src="getImageUrl(props.row.liveCover)">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <i class="el-icon-video-play"
                 style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
                 @click.stop="viewVideo(props.$index, props.row)"></i>

            </div>
          </template>

        </el-table-column>
        <el-table-column prop="liveDescription" label="视频描述" align="center" show-overflow-tooltip/>
        <el-table-column prop="price" label="观看费用" align="center" width="100"/>
        <el-table-column prop="liveCategory" label="直播科属" align="center" width="100"/>
        <el-table-column prop="liveVideoTab" label="视频标签" align="center">
          <template #default="props">
            <el-tag :key="props.row.liveVideoTabTitle" v-if="props.row.liveVideoTabTitle !== null">
              {{ props.row.liveVideoTabTitle }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="watchCount" label="观看次数" align="center" width="100"/>
        <el-table-column v-if="userOptions.length > 0" prop="userDataType" label="所属领域" align="center">
          <template #default="props">
            {{ props.row.userDataType | userDataTypeTransform }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button
              size="small"
              @click.stop="viewIncome(scope.$index, scope.row)"
            >
              收益
            </el-button> -->
            <el-button size="small" type="primary" @click.stop="go2ReviewDetail(scope.$index, scope.row)">
              详情
            </el-button>
            <el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
                       @click.stop="deleteReview(scope.$index, scope.row)">
              {{ scope.row.isDeleted ? "恢复" : "删除" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next,sizes" :total="totalCount" :page-size="pageSize"
                     :current-page="currentPage" @current-change="currentChange" :page-sizes="[10,20,50]"
                     @size-change="handleSizeChange"/>
    </el-card>

    <!-- 查看收益 -->
    <!-- <el-dialog title="查看收益" width="60%" :visible.sync="viewIncomeDialog">
      <el-table :data="gridData">
        <el-table-column align="center" property="CreditOrderID" label="#ID" />
        <el-table-column align="center" property="PayUserID" label="支付用户" />
        <el-table-column align="center" property="UserID" label="赚取用户" />
        <el-table-column
          align="center"
          property="CreditDescription"
          label="内容"
        />
        <el-table-column
          align="center"
          property="ModifyTime"
          label="消费时间"
        />
        <el-table-column
          align="center"
          property="CreditValue"
          label="赚取值(单位:麦粒)"
        />
      </el-table>
    </el-dialog>
 -->

    <!-- 查看视频 -->
    <el-dialog title="查看视频" :visible.sync="viewVideoDialog" width="60%" :destroy-on-close='true'>
      <!--			<video :src="getImageUrl(videoSrc)" controls style="width: 100%;height: 60vh;overflow: auto;" />-->
      <tx-video-player style="height: 60vh" :videoUrl="getImageUrl(videoSrc)"></tx-video-player>
    </el-dialog>

    <!-- editReviewDialog -->
    <el-dialog :title="editDlgType === 'create' ? '新增视频' : '编辑视频'" :visible.sync="editReviewDialog" width="60%"
               @close="editDlgClose" v-loading="dlgLoading">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="视频标题" required>
          <el-input v-model="form.liveTitle"/>
        </el-form-item>
        <el-form-item label="视频描述">
          <el-input v-model="form.liveDescription" type="textarea"/>
        </el-form-item>
        <div style="overflow:auto;height: 60vh;">
          <el-form-item label="收费规则">
            <el-radio-group v-model="form.payStatus">
              <el-radio v-for="item in payOptions" :label="item.value">{{ item.name }}</el-radio>
            </el-radio-group>
            <el-input-number size="small" style="margin-left: 20px;" v-model="form.price"
                             v-if="form.payStatus === 1"></el-input-number>
          </el-form-item>
          <el-form-item label="直播科属">
            <el-select v-model="form.categoryId" style="width: 100%">
              <el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
                         :label="item.categoryName" :value="item.forumCategoryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="userOptions.length > 0" label="所属领域">
            <el-select v-model="form.userDataType" style="width: 100%">
              <el-option v-for="item in userOptions" :key="item.value" :label="item.name"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频标签">
            <el-select v-model="form.liveVideoTabId" style="width: 100%" filterable @change="editReviewVideoTabChange">
              <el-option v-for="item in tabOptions" :key="item.liveVideoTabId"
                         :label="item.liveVideoTabTitle" :value="item.liveVideoTabId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                       :on-change="change2DisplayLocalImage" :auto-upload="false">
              <div style="text-align: left;">
                <el-image style="width: 100px; height: 100px"
                          :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(form.liveCover)"
                          fit="scale-down">
                  <template #error>
                    <p></p>
                  </template>
                </el-image>
                <br/>
                <el-button size="small" type="primary">点击上传</el-button>
              </div>

              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="editDlgType === 'create'" label="上传视频">
            <el-upload ref="uploadVideoRef" accept=".mp4" action="" class="upload-demo" :auto-upload="false"
                       :on-change="uplaodVideoChange" :limit="1">
              <div style="text-align: left;">
                <video id="upvideo" v-if="uploadVideoFile !== null"
                       :src="uploadVideoFile !== null ? uploadVideoFileURL : getImageUrl(form.pushFlowUrl)"
                       controls style="width: 100%;height: 30vh;overflow: auto;"/>
                <br/>
                <el-button size="small" type="primary">点击上传</el-button>
              </div>

              <div slot="tip" class="el-upload__tip">
                只能上传mp4文件
              </div>
            </el-upload>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editReviewDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="() => submitEdit()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <canvas id="mycanvas" style="display: none"></canvas>
  </div>
</template>

<script>
import {
  addTask
} from "@/utils/uploadManager"
import {
  addInfo,
  updateVideoInfo,
  deleteVideo,
  resumeVideo,
  getVideoListByTag,
  saveCommentFile,
  getCommentList,
  getLiveReviewCreditOrderList,
  addTag,
  deleteTag,
  setDefaultTag,
  updateTag,
  getTagList,
  getVideoDetail,
  getReplyLiveComment,
  getCategoryList,
  getWatchUserList
} from "@/api/mai/liveReviews/liveReviews";
import {
  handleRes
} from "@/utils/handleRes";
import {
  getCloudUrl,
  getLocalFileURL
} from "@/utils/urlutil"
import {
  getDisplayName, getUserType
} from "@/utils/userutil"
import {
  isVaild
} from "@/utils/validate"
import {
  printObj
} from "@/utils/debug"
import {
  deepClone
} from "@/utils/index"
import {
  getOSSUploadInfo
} from "@/api/system/CSDocument/file";
import {
  uploadFile2OSS
} from "@/utils/OSSUpload"
import txVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import UserInfo from "@/components/UserInfo/UserInfo";
import {export_json_to_excel} from "@/vendor/Export2Excel";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  props: {
    initSearchValue: {
      type: String,
      default: "",
    },
  },
  components: {
    UserInfo,
    txVideoPlayer
  },
  data() {
    return {
      navigationKey:"reviewList",

      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      activeName: "视频列表",
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      viewIncomeDialog: false, // 查看收益对话框
      viewCoverDialog: false,
      viewVideoDialog: false,
      editReviewDialog: false,
      dlgLoading: false,
      coverSrc: "",
      videoSrc: "",
      addReviewTagsDialog: false,
      editVideoTagsDialog: false,
      tableData: [], // 表格数据
      gridData: [], // 收益表格数据
      form: {},
      userOptions: [],
      curUserOption: "",
      payOptions: [{
        name: "免费",
        value: 0
      },
        {
          name: "付费",
          value: 1
        }
      ],
      tabOptions: [],
      curTabOption: "",
      // filterOptions: [],
      // curFilterOptions: [],
      categoryOptions: [],
      curCategoryOption: "",
      sortOptions: [{
        name: "按时间排序",
        value: "CreateTime"
      }, {
        name: "按播放量排序",
        value: "WatchCount"
      }],
      curSortOption: "",
      maiColumnID: -1,
      editDlgType: "",
      //上传视频、封面相关
      uploadCoverFile: null,
      uploadVideoFile: null,
      uploadCoverFileURL: "",
      uploadVideoFileURL: "",
      uploadCoverFromVideo: "",
    };
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.currentPage = navigationObj.currentPage
    this.pageSize = navigationObj.pageSize
    this.searchValue = navigationObj.searchValue
    this.curUserOption = navigationObj.curUserOption
    this.curSortOption = navigationObj.curSortOption
    this.curTabOption = navigationObj.curTabOption
    this.curCategoryOption = navigationObj.curCategoryOption

    this.searchValue = this.initSearchValue
    this.refreshCurrentList();
    this.getAllTag();
    // this.getColumnCondictionList()
    this.getCategoryOptions()
    this.userOptions = getUserType()
  },
  methods: {
    go2uploadmanager() {
      this.$router.push({
        name: "uploadManage",
      })
    },
    //选择后界面不会更新………………
    editReviewVideoTabChange(value) {
      this.$forceUpdate()
    },
    async uplaodVideoChange(uploadFile) {
      this.$refs.uploadVideoRef.clearFiles()
      this.uploadVideoFile = uploadFile
      this.uploadVideoFileURL = getLocalFileURL(uploadFile)
      let duration = await this.getVideoDuration(this.uploadVideoFileURL);
      // this.uploadVideoTimeLength = duration / 1000;
      this.getVideoCover(this.uploadVideoFileURL)
    },
    getVideoDuration(url) {

      return new Promise((reslove) => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.onloadedmetadata = () => {
          reslove(parseInt((video.duration * 1000).toString(), 10));
          video = null;
        };
      });
    },
    editDlgClose() {
      this.uploadCoverFile = null
      this.uploadCoverFileURL = ""
      this.uploadVideoFile = null
      this.uploadVideoFileURL = ""
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    curTabOptionChange() {
      this.search()
    },
    curCategoryChange() {
      this.search()
    },
    curSortOptionChange() {
      this.search()
    },
    curUserOptionChange() {
      this.search()
    },
    // async getColumnCondictionList() {
    // 	await this.getColumnID()
    // 	let getColumnCondictionListRes = await getColumnCondictionList({
    // 		maiColumnID: this.maiColumnID,
    // 		lang: 0
    // 	})
    // 	if (isVaild(getColumnCondictionListRes)) {
    // 		this.filterOptions = getColumnCondictionListRes.resultData
    // 	}

    // },
    // async getColumnID() {
    // 	this.maiColumnID = await getMaiColumnID("wonderful_live")
    // },
    getAllTag() {
      getTagList({
        pageSize: 0
      }).then((res) => {
        this.tabOptions = res.data.rows
      });
    },
    isVaild(value) {
      return isVaild(value)
    },
    async getCategoryOptions() {
      let res = await getCategoryList()
      if (isVaild(res)) {
        this.categoryOptions = res.data
      }

    },
    getName(user) {
      return getDisplayName(user)
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    getLocalFileURL(file) {
      return getLocalFileURL(file)
    },
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.getVideoList();
    },
    /**
     * 切换tab
     */
    handleClick() {
      this.currentPage = 1;
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },
    /**
     * 页面大小改变
     * @param size
     */
    handleSizeChange(size){
      this.pageSize = size
      this.currentPage = 1
      this.refreshCurrentList()
    },
    /**
     * 获取视频列表
     */
    getVideoList() {
      this.loading = true;
      const params = {
        keyWord: this.searchValue,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        liveVideoTabId: this.curTabOption,
        lang: 0,
        sortName: this.curSortOption,
        userDataType: this.curUserOption
      };
      if (isVaild(this.curCategoryOption)) {
        params.where = [{
          "field": "categoryID",
          "value": this.curCategoryOption,
          "op": "equal"
        }]
      }
      setNavigationItemWithObj(this.navigationKey,{
        searchValue:this.searchValue,
        currentPage:this.currentPage,
        pageSize:this.pageSize,
        curTabOption:this.curTabOption,
        curSortOption:this.curSortOption,
        curUserOption: this.curUserOption,
        curCategoryOption:this.curCategoryOption
      })

      getVideoListByTag(params).then((res) => {
        console.log(" ---------------------------");
        console.log("getVideoListByTag , res", res);
        console.log(" ---------------------------");
        this.tableData = res.data.rows;
        this.totalCount = res.data.total;
        this.loading = false;
      });
    },
    /**
     * 收益
     */
    viewIncome(scope, row) {
      const params = {
        LiveID: row.liveId,
        pageNumber: 0,
      };
      getLiveReviewCreditOrderList(params).then((res) => {
        console.log(" ------------------------------");
        console.log("params", params);
        console.log(" ------------------------------");
        this.gridData = res.Rows;
      });
      this.viewIncomeDialog = true;
    },
    /**
     * 视频
     */
    viewVideo(index, row) {
      this.videoSrc = row.pushFlowUrl;
      this.viewVideoDialog = true;
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    handlePreview(file) {
      console.log(file);
    },
    addReview() {
      this.form = {}
      this.showEditDlg('create')
    },
    /**
     *`
     */
    go2ReviewDetail(index, row) {
      this.$router.push({
        path: "liveReviewDetail",
        query: {
          liveID: row.liveId
        }
      })
      // console.log("+++++++++++++++")
      // this.form = {}; //清空数据
      // this.form = deepClone(row);
      // let res = this.categoryOptions.filter((item) => {
      //   return item.categoryName === this.form.liveCategory;
      // })
      // if (res.length > 0) {
      //   this.form.categoryId = res[0].forumCategoryId
      // } else {
      //   this.form.categoryId = ""
      // }
      //
      // let tabRes = this.tabOptions.filter((item) => {
      //   return item.liveVideoTabTitle === this.form.liveVideoTabTitle
      // })
      // if (tabRes.length > 0) {
      //   this.form.liveVideoTabId = tabRes[0].liveVideoTabId
      // } else {
      //   this.form.liveVideoTabId = ""
      // }
      // this.showEditDlg('edit')
    },
    showEditDlg(type) {
      this.editDlgType = type;
      this.editReviewDialog = true;
    },
    /**
     * 提交视频
     */
    async submitEdit() {
      if (!isVaild(this.uploadVideoFile) && this.editDlgType === 'create') {
        this.$message.warning("请选择视频")
        return
      }
      console.log('submit edit ')
      this.dlgLoading = true;

      //FIXME：获取上传路径
      let savepathParamsRes = await getOSSUploadInfo({
        DataType: "10",
        ID: "0",
      });
      if (!isVaild(savepathParamsRes)) {
        return;
      }
      let savePathParams = savepathParamsRes.resultData
      //上传封面
      if (isVaild(this.uploadCoverFile) || isVaild(this.uploadCoverFromVideo)) {
        // printObj(this.uploadCoverFile.raw)
        let timestamp = new Date().valueOf();

        let uploadRes;
        let fileName;
        if (isVaild(this.uploadCoverFile)) {
          fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
          uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
            type: this.uploadCoverFile.raw.type
          }), fileName)
        } else if (isVaild(this.uploadCoverFromVideo)) {
          let data = this.uploadCoverFromVideo
          var str = data.split(",");
          var suffix = data.split(";")[0].split("/")[1];
          // console.log("IMG-Suffix====>>", suffix)
          fileName = savePathParams.PicSavePath + "cover_from_video_" +
              timestamp + "." + suffix;
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

          //base64
          var buffer = Buffer.from(str[1], 'base64');
          uploadRes = await uploadFile2OSS(savePathParams, buffer, fileName)
        }
        if (uploadRes.status === 0) {
          this.form.liveCover = this.config.RESOURCES + "/" + fileName
          // console.log(this.form.liveCover)
        } else {
          this.$message({
            type: "error",
            message: "上传失败"
          })
        }
        this.$refs.uploadCoverRef.clearFiles();
      }


      let data = deepClone(this.form)

      //上传视频
      if (isVaild(this.uploadVideoFile)) {
        //视频比较大，后台上传
        this.dlgLoading = false;
        let timestamp = new Date().valueOf();
        const fileName = savePathParams.PicSavePath + timestamp + this.uploadVideoFile.name.substring(this.uploadVideoFile.name.lastIndexOf("."));
        // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

        let uploadRes = await addTask({
          from: "往期回顾",
          ossInfo: savePathParams,
          file: new Blob([this
              .uploadVideoFile.raw
          ], {
            type: this.uploadVideoFile.raw.type
          }),
          filePath: fileName,
          orgName: this.uploadVideoFile.name,
          finishCallback: async (uploadInfo) => {
            data.pushFlowUrl = this.config.RESOURCES + "/" + fileName
            let res = await addInfo(data);
            if (res.code === 200) {
              uploadInfo.status = 3
            } else {
              uploadInfo.status = 2
              uploadInfo.remarks = res.message
            }
          }
        }, (status) => {
          if (status.status === 0) {

            this.editReviewDialog = false;
            this.$message.success("已添加到上传任务")
          } else {
            this.$message.warning(status.msg)
          }
        })

        // let uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadVideoFile.raw], {
        // 	type: this.uploadVideoFile.type
        // }), fileName)
        // if (uploadRes.status === 0) {
        // 	this.form.pushFlowUrl = "/" + fileName
        // 	// console.log(this.form.pushFlowUrl)
        // } else {
        // 	this.$message({
        // 		type: "error",
        // 		message: "上传失败"
        // 	})
        // }
        // this.$refs.uploadVideoRef.clearFiles();
      }
      //
      if (this.editDlgType === 'create') {
        // 	//FIXME:创建
        // 	let createRes = await addInfo(data);
        // 	if (createRes.code === 200) {
        // 		this.$message.success("上传成功")
        // 	} else {
        // 		this.$message.warning(res.message)
        // 	}
        // 	this.search()
      } else if (this.editDlgType === 'edit') {
        //更新
        updateVideoInfo(data)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.errorMessage,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            });
        this.refreshCurrentList()
        // console.log("upload finish ")
        this.dlgLoading = false;
        this.editReviewDialog = false;

      }


    },
    getVideoCover(url) {
      const video = document.getElementById("upvideo"); // 获取视频对象
      // const video = document.createElement("video") // 也可以自己创建video
      // console.log('----- getVideoCover ' + video)
      video.src = url; // url地址 url跟 视频流是一样的
      var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        this.imgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.uploadCoverFromVideo = this.imgsrc;
        // console.log(this.uploadCoverFromVideo)
      };
    },
    /**
     *
     */
    deleteReview(index, row) {
      let msg = row.isDeleted ? '是否恢复该视频' : '是否删除该视频'
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            deleteVideo({
              liveId: row.liveId
            }).then((res) => {
              console.log(" ---------------------");
              console.log("deleteVideo , res", res);
              console.log(" ---------------------");
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.refreshCurrentList()
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },

    /**
     *
     */
    addReviewTags() {
      this.addReviewTagsDialog = true;
    },

    /**
     *
     */
    editVideoTags() {
      this.editVideoTagsDialog = true;
    },

    /**
     *
     */
    deleteReviewTags(index, row) {
      console.log(index, row);
      this.$confirm("是否删除该视频", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功",
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
    async exportVideoTabAllWatchData() {
      //获取videoTab以及搜索条件下所有数据
      this.loading = true;
      const params = {
        liveId: -1,
        liveVideoTabId: this.curTabOption,
        pageNumber: 1,
        pageSize: 0,
        sortName: "",
        sortOrder: ""
      };
      let res = await getWatchUserList(params)
      handleRes(res, async () => {
        let dataList = res.data.rows

        //遍历数据拿liveID获取全部观看信息
        this.export2Excel(dataList)

      })
      this.loading = false

      //导出excel
    },
    export2Excel(exportData) {
      let {
        tName,
        tHeader,
        filterValue
      } = this.getExcelInfo()
      let list = this.formatChatInfoTable(exportData)
      let data = this.formatJson(filterValue, list)
      export_json_to_excel({
        header: tHeader,
        data,
        filename: tName,
        autoWidth: true,
        bookType: "xlsx",
      })
    },
    getExcelInfo() {
      let tName = '用户观看数据统计';
      let tHeader;
      let filterValue;
      tHeader = ['视频标题', 'ID', '观看者', '用户ID', '手机', '单位', '开始时间', '结束时间', '观看时长(min)']
      filterValue = [
        'videoTitle',
        'userVideoWatchId',
        'nickname',
        'userId',
        'mobilePhone',
        'organization',
        'startTime',
        'endTime',
        'watchTimeLength',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }

    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
    /**
     * 格式化 userInfoTable
     *
     * @param list
     */
    formatChatInfoTable(list) {
      let newList = list.map(item => {
        item.userName = item.firstName + item.lastName
        item.startTime = this.$options.filters["formatDateTime"](item.startTime)
        item.endTime = this.$options.filters["formatDateTime"](item.endTime)
        item.nickname = getDisplayName(item)
        item.watchTimeLength = this.$options.filters["formatSecond2Min"](item.watchTimeLength)
        return item
      })

      return newList
    },
  },
};
</script>

<style scoped lang="scss"></style>
